export default __webpack_public_path__ + "static/media/1032.cbbbab87.png";